import { memo } from 'react';
import { FeatureGroup, LayersControl } from 'react-leaflet';

import MapSiteFeature from '../../components/Maps/MapSiteFeature';
import Shape from '../../components/Maps/Shape';
import { LAYER_NAME } from '../../components/Maps/constants';

import HeatmapLayer from './HeatmapLayer';

const { Overlay } = LayersControl;

function CustomLayers({ features_master, features, features_sites, grazing, selected }) {
  return (
    <>
      {grazing?.length > 0 && (
        <Overlay checked name={LAYER_NAME.GRAZING}>
          <FeatureGroup edit={{ edit: false, delete: false }}>
            <HeatmapLayer points={grazing} />
          </FeatureGroup>
        </Overlay>
      )}

      {features_master?.features?.length > 0 && (
        <Overlay checked name={LAYER_NAME.FARMS}>
          <FeatureGroup edit={{ edit: false, delete: false }}>
            {features_master?.features?.map(item => (
              <Shape
                isSelected={selected?.map(i => i.id)?.includes(item.properties?.id)}
                item={item}
                key={item.properties?.id}
                path={`farms/${item.properties?.farm_id}`}
              />
            ))}
          </FeatureGroup>
        </Overlay>
      )}
      {features?.features?.length > 0 && (
        <Overlay checked name={LAYER_NAME.GEOFENCES}>
          <FeatureGroup edit={{ edit: false, delete: false }}>
            {features?.features?.map(item => (
              <Shape
                isSelected={selected?.map(i => i.id)?.includes(item.properties?.id)}
                item={item}
                key={item.properties?.id}
                path={`pastures/${item.properties?.id}`}
              />
            ))}
          </FeatureGroup>
        </Overlay>
      )}
      {features_sites?.features?.length > 0 && (
        <Overlay checked name={LAYER_NAME.SITES}>
          <FeatureGroup edit={{ edit: false, delete: false }}>
            {features_sites?.features?.map(item => (
              <MapSiteFeature
                color={item?.color}
                geometry={item?.geometry?.coordinates}
                isSelected={selected?.map(i => i.id)?.includes(item.properties?.id)}
                key={item.properties?.id}
                properties={item?.properties}
                type={item?.geometry?.type}
              />
            ))}
          </FeatureGroup>
        </Overlay>
      )}
    </>
  );
}

export default memo(CustomLayers);
